// Card payments are made on the provider's page, opened in a new tab, while
// this tab waits for the confirmation on the return page
export const openCardCheckout = (navigate, payment) => {
  const tab = window.open(payment.paymentUrl, "_blank");

  // The provider's page must not control ours
  if (tab) tab.opener = null;

  navigate("/check-payment");
};
